// Scratch Standard Color Palette for PixelBlock
const PIXELBLOCK_COLORS = {
    looks: {
        colourPrimary: '#9966FF',
        colourSecondary: '#855CD6',
        colourTertiary: '#774DCB',
        colourQuaternary: '#774DCB'
    },
    control: {
        colourPrimary: '#FFAB19',
        colourSecondary: '#EC9C13',
        colourTertiary: '#CF8B17',
        colourQuaternary: '#CF8B17'
    },
    sensing: {
        colourPrimary: '#5CB1D6',
        colourSecondary: '#47A8D1',
        colourTertiary: '#2E8EB8',
        colourQuaternary: '#2E8EB8'
    },
    operators: {
        colourPrimary: '#59C059',
        colourSecondary: '#46B946',
        colourTertiary: '#389438',
        colourQuaternary: '#389438'
    },
    variables: {
        colourPrimary: '#FF8C1A',
        colourSecondary: '#FF8000',
        colourTertiary: '#DB6E00',
        colourQuaternary: '#DB6E00'
    },
    lists: {
        colourPrimary: '#FF661A',
        colourSecondary: '#FF5500',
        colourTertiary: '#E64D00',
        colourQuaternary: '#E64D00'
    },
    // Aliases to ensure complete backward compatibility
    output: {
        colourPrimary: '#9966FF',
        colourSecondary: '#855CD6',
        colourTertiary: '#774DCB',
        colourQuaternary: '#774DCB'
    },
    decisions: {
        colourPrimary: '#FFAB19',
        colourSecondary: '#EC9C13',
        colourTertiary: '#CF8B17',
        colourQuaternary: '#CF8B17'
    },
    iteration: {
        colourPrimary: '#FFAB19',
        colourSecondary: '#EC9C13',
        colourTertiary: '#CF8B17',
        colourQuaternary: '#CF8B17'
    },
    input: {
        colourPrimary: '#5CB1D6',
        colourSecondary: '#47A8D1',
        colourTertiary: '#2E8EB8',
        colourQuaternary: '#2E8EB8'
    },
    values: {
        colourPrimary: '#59C059',
        colourSecondary: '#46B946',
        colourTertiary: '#389438',
        colourQuaternary: '#389438'
    },
    conversions: {
        colourPrimary: '#59C059',
        colourSecondary: '#46B946',
        colourTertiary: '#389438',
        colourQuaternary: '#389438'
    },
    data: {
        colourPrimary: '#FF8C1A',
        colourSecondary: '#FF8000',
        colourTertiary: '#DB6E00',
        colourQuaternary: '#DB6E00'
    },
    data_lists: {
        colourPrimary: '#FF661A',
        colourSecondary: '#FF5500',
        colourTertiary: '#E64D00',
        colourQuaternary: '#E64D00'
    }
};

export default PIXELBLOCK_COLORS;
